<template>
  <div class="assetDetailTagsTopics">
    <div class="assetDetailTagsTopics-title">
      <h4>Topics</h4>
    </div>
    <div class="assetDetailTagsTopics-content">
      <pill v-for="topic in topics"
        :key="topic.subject"
      >
        {{ topic.subject }}
      </pill>
    </div>
  </div>
</template>

<script>
import Pill from './Pill.vue'

export default {
  name: 'AssetDetailTagsTopics',

  components: {
    Pill
  },

  props: {
    topics: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.assetDetailTagsTopics {
  &-title {
    border-bottom: 1px solid $very-light-pink;
    padding-bottom: 5px;

    h4 {
      font-family: $defaultFont;
      font-size: 12px;
      color: $slate-grey;
      margin: 0;
      font-weight: 400;
    }
  }

  &-content {
    display: flex;
    flex-wrap: wrap;
    column-gap: 5px;
    row-gap: 5px;
    padding-top: 10px;
  }
}
</style>
